import { toast } from "react-toastify";
import CloseIcon from "../svg/close";
import "../../utils/tailwind.css";

const CloseButton = ({ closeToast }) => (
  <button
    onClick={closeToast}
    className="absolute right-4 top-4 bg-transparent border-none text-white cursor-pointer"
  >
    <CloseIcon />
  </button>
);

const useToaster = () => {
  const props = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: true,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: false,
    icon: false,
    closeButton: CloseButton,
  };

  const toastContent = (label, desc) => (
    <div>
      <div className="text-lg font-medium mb-1 text-[21px]">{label}</div>
      <div className="text-sm font-normal mb-3 text-[14px]">{desc}</div>
    </div>
  );

  const success = (label, desc) => {
    toast.success(toastContent(label, desc), {
      ...props,
      className: "bg-green-700 text-white rounded-xl w-[327px] h-[105px] p-3",
    });
  };

  const warning = (label, desc) => {
    toast.warning(toastContent(label, desc), {
      ...props,
      className: "bg-yellow-600 text-white rounded-xl w-[327px] h-[105px] p-3",
    });
  };

  const error = (label, desc) => {
    toast.error(toastContent(label, desc), {
      ...props,
      className: "bg-red-700 text-white rounded-xl w-[327px] h-[105px] p-3",
    });
  };

  const clear = () => {
    toast.dismiss();
  };

  return { success, warning, error, clear };
};

export default useToaster;
